import ReactDOM from "react-dom";
import { useEffect, useRef } from "react";

// Scrolls to top of active Part Detail form when component is mounted.
export default function useScrollToOnMount() {
  const ref = useRef(null);

  useEffect(
    () => {
      if (ref.current) {
        // NOTE: I haven't found a better way to access the underlying DOM node
        // when ref.current returns a Component. ReactDOM.findDOMNode seems to
        // handle both raw elements and Components, so this should be a safe
        // solution other than having to disable eslint rule.
        // eslint-disable-next-line react/no-find-dom-node
        const domNode = ReactDOM.findDOMNode(ref.current);
        const newPositionY =
          domNode.getBoundingClientRect().top + window.scrollY - 70;

        window.scrollTo(0, newPositionY);
      }
      return () => {};
    },
    [ref]
  );

  return ref;
}



// WEBPACK FOOTER //
// ./app/hooks/useScrollToOnMount.js